import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./hooks/AuthContext";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <GoogleOAuthProvider clientId="564962151092-jhalf0u6ppecvqpfe2ab66nlbqr3qmc8.apps.googleusercontent.com">
        <AuthProvider>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,

  document.getElementById("root")
);
